module.exports = __webpack_public_path__ + "static/media/khilkovsky_1_5.9fd9a520.pdf";